/**
 * Adapter: AccountThemeDto → AccountThemeAdapterResult.
 *
 * Re-exported from @course-authoring/shared-types. The authoring
 * AccountThemeDto (from accountThemeApi) is a structural superset of the
 * shared minimal AccountThemeDto, so the shared adapter works for both.
 */
import type { AccountThemeAdapterResult } from '@course-authoring/shared-types';
import {
  adaptAccountThemeDto as sharedAdaptAccountThemeDto,
  CUSTOM_FONT_SENTINEL,
} from '@course-authoring/shared-types';
import type { AccountThemeDto as AuthoringAccountThemeDto } from '../api/accountThemeApi';

export type { AccountThemeAdapterResult };

// Re-exported so existing importers of the sentinel from this module keep working.
export { CUSTOM_FONT_SENTINEL };

/**
 * Convert an `AccountThemeDto` from the API into an `AccountThemeAdapterResult`
 * ready for `mapAccountThemeToTokens`. Delegates to the shared implementation.
 */
export function adaptAccountThemeDto(dto: AuthoringAccountThemeDto): AccountThemeAdapterResult {
  // The authoring DTO is a structural superset; the shared adapter reads only
  // the subset fields it needs, so it is safe to cast here.
  return sharedAdaptAccountThemeDto(dto);
}
